import {
  cond, equals, includes, T,
} from 'ramda';

export const getPageTitleByUrl = cond([
  [equals('/how-we-work'), () => 'How We Work'],
  [includes('/what-we-do'), () => 'What We Do'],
  [equals('/who-we-are'), () => 'Who We Are'],
  [includes('/contacts'), () => 'Contacts'],
  [includes('/search'), () => 'Search'],
  [equals('/imprint'), () => 'Imprint'],
  [equals('/terms'), () => 'Terms'],
  [equals('/privacy'), () => 'Privacy'],
  [T, () => 'healthcare innovations'],
]);

const handleItem = (translate) => ({ tags, ...rest }) => ({
  ...rest,
  tags: tags.map((key) => ({ name: translate(key), key })),
});

export const handleWhoWeAreContent = (content, translate) => ({
  ...content,
  management: content.management.map(handleItem(translate)),
  team: content.team.map(handleItem(translate)),
  network: content.network.map(handleItem(translate)),
});
